const device = {
  Android() {
    return typeof window !== 'undefined' ? navigator.userAgent.match(/Android/i) : null;
  },
  BlackBerry() {
    return typeof window !== 'undefined' ? navigator.userAgent.match(/BlackBerry/i) : null;
  },
  iOS() {
    return typeof window !== 'undefined' ? navigator.userAgent.match(/iPhone|iPod|iPad/i) : null;
  },
  Chrome() {
    return typeof window !== 'undefined' ? navigator.userAgent.match(/Chrome/i) : null;
  },
  Firefox() {
    return typeof window !== 'undefined' ? navigator.userAgent.match(/Firefox/i) : null;
  },
  Safari() {
    return typeof window !== 'undefined' ? navigator.userAgent.match(/Safari/i) : null;
  },
  OperaMini() {
    return typeof window !== 'undefined' ? navigator.userAgent.match(/Opera Mini/i) : null;
  },
  IE() {
    return typeof window !== 'undefined' ? navigator.userAgent.match(/MSIE/i) : null;
  },
  Windows() {
    return typeof window !== 'undefined' ? navigator.userAgent.match(/IEMobile/i) : null;
  },
  any() {
    return !!(device.Android() || device.BlackBerry() || device.iOS() || device.OperaMini() || device.Windows());
  },
};

const isMobile = device.any();
const isChrome = !!device.Chrome();
const isFirefox = !!device.Firefox();
const isSafari = !!device.Safari();
const isOperaMini = !!device.OperaMini();
const isIE = !!device.IE();

export { device, isChrome, isFirefox, isSafari, isOperaMini, isIE, isMobile };
